var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"dense":""}},[_c('v-col',{staticClass:"mx-n3"},[_c('div',{staticClass:"mt-14",attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"area","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }